import intermind from '../../../index';
import { ListConfig, ListParams, ListResponse } from '../../../types';
import { AdminPrompt, Prompt, PromptCreateDto, PromptUpdateDto } from '../../ai/types/prompt.types';

export class AdminPromptResource {
  // ===== Predefined Prompts =====
  async getPromptListConfig(): Promise<ListConfig> {
    const { data } = await intermind.httpClient.get<ListConfig>('/admin/prompts/list-config');
    return data;
  }

  async listPrompts(params?: ListParams): Promise<ListResponse<AdminPrompt>> {
    const { data } = await intermind.httpClient.get<ListResponse<AdminPrompt>>('/admin/prompts', { params });
    return data;
  }

  async createPrompt(dto: PromptCreateDto): Promise<AdminPrompt> {
    const { data } = await intermind.httpClient.post<AdminPrompt>('/admin/prompts', dto);
    return data;
  }

  async updatePrompt(id: string, dto: PromptUpdateDto): Promise<AdminPrompt> {
    const { data } = await intermind.httpClient.put<AdminPrompt>(`/admin/prompts/${id}`, dto);
    return data;
  }

  async deletePrompt(id: string): Promise<void> {
    await intermind.httpClient.delete(`/admin/prompts/${id}`);
  }

  // ===== User Custom Prompts =====
  async listUserPrompts(userId: string, params?: ListParams): Promise<ListResponse<Prompt>> {
    const { data } = await intermind.httpClient.get<ListResponse<Prompt>>(`/admin/users/${userId}/prompts`, {
      params,
    });
    return data;
  }

  async createUserPrompt(userId: string, dto: PromptCreateDto): Promise<Prompt> {
    const { data } = await intermind.httpClient.post<Prompt>(`/admin/users/${userId}/prompts`, dto);
    return data;
  }

  async updateUserPrompt(userId: string, promptId: string, dto: PromptUpdateDto): Promise<Prompt> {
    const { data } = await intermind.httpClient.put<Prompt>(`/admin/users/${userId}/prompts/${promptId}`, dto);
    return data;
  }

  async deleteUserPrompt(userId: string, promptId: string): Promise<void> {
    await intermind.httpClient.delete(`/admin/users/${userId}/prompts/${promptId}`);
  }
}
